<template>
  <div
      :class="page"
      class="news">
    <div class="content">
      <router-link :to="{ path: '/news' }" class="title">
        {{ title }}
      </router-link>

      <div class="news__wrapper">
        <div
          v-for="(item, index) in items"
          class="news__item"
          :key="index">
          <router-link
              :to="{ name: 'novelty', params: { slug: item.id } }"
              :class="['news__link', item.linkClass]"/>

          <div class="news__info">
            <p
              v-text="item.date"
              class="news__date"/>

            <p
              v-text="item.title"
              class="news__title"/>

            <p
              v-text="item.description"
              class="news__description"/>
          </div>

          <div class="news__thumb">
            <img
              :alt="item.title"
              :src="require(`@/assets/img/${item.thumb}`)"
              :title="item.title"/>
          </div>
        </div>
      </div>
      <router-link
          :to="{ path: '/news' }"
          class="news__wrapper__more">
          <p>More news</p>
          <img src="@/assets/img/news/arrow.svg" alt="arrow-icon" />
        </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'News',
  props: {
    items: {
      type: Object,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
